export const getVolumesLoading = state => state.volumes?.loading || false
export const getVolumesDataByIdLoading = state => state.volumes?.volumeLoading || false
export const getIssueByIdLoading = state => state.volumes?.issueLoading || false
export const getArticleByIdLoading = state => state.volumes?.articleLoading || false
export const getAllArticlesLoading = state => state.volumes?.data?.articlesLoading || false
export const getArticleReferenceByIdLoading = state =>
  state.volumes?.articleReferenceLoading || false
